import { ApolloError } from '@apollo/client';
import * as Sentry from '@sentry/react';
import type { RootOptions } from 'react-dom/client';

export { default, default as useErrorBoundary } from './use-error-boundary';

export const initSentry = () => {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    return;
  }
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tunnel: import.meta.env.VITE_PUBLIC_SENTRY_HOST,
    environment: import.meta.env.VITE_ENV,
    tracesSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
    ],
  });
};

export const createReactRootOptions = (): RootOptions => {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    return {};
  }

  return {
    onRecoverableError: Sentry.reactErrorHandler(),
    onUncaughtError: Sentry.reactErrorHandler(),
  };
};

export const captureException = (error: Error | ApolloError) => {
  Sentry.captureException(error);
};

export const captureMessage = (message: string) => {
  Sentry.captureMessage(message);
};
